import { useMutation } from "@tanstack/react-query";

import { api } from "@contexts";
import type { PrescriptionTemplateDetail, TemplateType } from "@interfaces";

interface CreateTemplateProps {
  name: string;
  templateType: TemplateType;
  prescriptionDetails: PrescriptionTemplateDetail[];
}

export const useCreateTemplate = () => {
  return useMutation({
    mutationFn: async (data: CreateTemplateProps) => {
      return api({
        method: "PUT",
        url: "/templates/new",
        data: JSON.stringify(data),
      });
    },
  });
};
